import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';

import styles from './ThreePart.module.less';
import { logging, logPostInfo } from '../../../actions/log';
import { CONTEXT } from '../../../config';
import { changeClass } from '../../../utils/utils';
import Button from '../../Button/Button';
import GameRate from '../GameRate/GameRate';
import ImgVideo from '../ImgVideo/ImgVideo';
import _LogInView from '../../_LogInView/_LogInView';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const [showMore, setShowMore] = useState(false);
  const [softDom, setSoftDom] = useState(null);
  const [moreDom, setMoreDom] = useState(null);
  const [moreVIDom, setMoreVIDom] = useState(null);
  const [moreInfoDom, setMoreInfoDom] = useState(null);

  const handleSoftCard = useCallback(() => {
    const source = logInfo ? logInfo.source : 'SoftCard_err';
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          ...logInfo,
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
      }),
    );
    if (soft.androidType === '1') {
      history.push(
        `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`,
      );
    } else {
      history.push(`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`);
    }
  });

  const onMouseOver = useCallback(() => {
    // 控制悬浮展示
    if (!showMore) {
      changeClass(moreDom, styles.mouse_in, styles.mouse_out);
      changeClass(moreVIDom, styles.mouse_in, styles.mouse_out);
      changeClass(moreInfoDom, styles.mouse_in_info, styles.mouse_out_info);
      const timeoutIndex = setTimeout(() => {
        loggingHover();
      }, 1000);
      setShowMore({ timeoutIndex });
    }
  }, [moreDom, moreVIDom, moreInfoDom, showMore]);
  const onMouseLeave = useCallback(() => {
    if (moreDom) {
      changeClass(moreDom, styles.mouse_out, styles.mouse_in);
      changeClass(moreVIDom, styles.mouse_out, styles.mouse_in);
      changeClass(moreInfoDom, styles.mouse_out_info, styles.mouse_in_info);
      clearTimeout(showMore.timeoutIndex);
      setShowMore(null);
    }
  }, [moreDom, moreVIDom, moreInfoDom, showMore]);

  const loggingHover = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: `${logInfo?.clTag || logInfo?.tag}_Content_Hover`,
        label: '',
        param2: {
          ...logInfo,
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
  }, []);

  const createSoftTag = useCallback(tags => {
    if (!tags || tags.length === 0) {
      return '';
    }
    let arr = [];
    for (let i = 0; i < tags.length; i++) {
      arr.push(tags[i].name);
    }
    return arr.join(' / ');
  }, []);

  const formatPriceType3 = useCallback((num = '0') => {
    return parseFloat((num || '0')?.replace('¥', '').replace('￥', ''));
  }, []);
  const formatPrice = useCallback((num = '0') => {
    return `${parseFloat((parseInt(num) / 100).toFixed(2)) || 0}`;
  }, []);
  const formatPriceZK = useCallback((cu_, or_) => {
    let cu = parseFloat(cu_);
    let or = parseFloat(or_);
    if (cu && or) {
      return `${parseFloat((cu / or).toFixed(2)) * 10 || 0}`;
    }
    return '';
  }, []);

  return (
    <_LogInView cardData={soft} logInfo={logInfo}>
      <div
        className={styles.soft_item}
        onMouseOver={e => onMouseOver(e)}
        onMouseLeave={e => onMouseLeave(e)}
        ref={r => setSoftDom(r)}
        onClick={handleSoftCard}
      >
        <div className={`soft_bg_img`}>
          {soft?.vImg || soft?.ztImg ? (
            <img className="soft_img" src={soft?.vImg || soft?.ztImg} />
          ) : (
            <div className="soft_img_"></div>
          )}
        </div>
        <div className={`soft_info`}>
          <div className={`soft_names`}>
            <div className={`soft_name`}>{soft?.softName}</div>
            {soft?.androidType === '1' && <div className={`soft_point_and`}></div>}
            {soft?.androidType !== '1' && soft?.installFileType === 1 && (
              <div className={`soft_point_dlc`}></div>
            )}
          </div>
          <div className={`soft_line1`}>
            <div className={`soft_rate_dl`}>
              <div className={`soft_rate`}>
                <GameRate score={parseInt(parseInt(soft?.score || 60) / 20)} styleType={`white`} />
              </div>
              <div className={`soft_dl`}>{soft?.downloadCount}安装</div>
            </div>

            {soft?.androidType === '3' &&
              soft?.sourceInfo &&
              soft?.sourceInfo?.sellInfo &&
              soft?.sourceInfo?.sellInfo?.discount && (
                <div className={`soft_price_zk`}>{soft?.sourceInfo?.sellInfo?.discount} 折</div>
              )}
            {soft?.payType === 1 &&
              soft?.currentPrice &&
              soft?.originalPrice &&
              soft?.currentPrice !== soft?.originalPrice && (
                <div className={`soft_price_zk`}>
                  {formatPriceZK(soft?.currentPrice, soft?.originalPrice)} 折
                </div>
              )}
          </div>
          <div className={`soft_line2`}>
            {soft?.relationTags && soft?.relationTags?.length > 0 ? (
              <div className={`soft_tags`}>
                {soft?.relationTags.slice(0, 2).map((item, i) => (
                  <div className={`soft_tag`} key={i}>
                    {item.name}
                  </div>
                ))}
              </div>
            ) : (
              <div className={`soft_tags_desc`}>{soft?.introduction}</div>
            )}

            {soft?.androidType === '3' &&
              soft?.sourceInfo &&
              soft?.sourceInfo?.sellInfo &&
              (soft?.sourceInfo?.sellInfo?.currentPrice ||
                soft?.sourceInfo?.sellInfo?.originalPrice) && (
                <div className={`soft_price_co`}>
                  {((soft?.sourceInfo?.sellInfo?.currentPrice &&
                    !soft?.sourceInfo?.sellInfo?.originalPrice) ||
                    (!soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice) ||
                    soft?.sourceInfo?.sellInfo?.currentPrice ===
                      soft?.sourceInfo?.sellInfo?.originalPrice) && (
                    <div className={`soft_price_c`}>
                      ¥
                      {formatPriceType3(
                        soft?.sourceInfo?.sellInfo?.currentPrice ||
                          soft?.sourceInfo?.sellInfo?.originalPrice,
                      )}
                    </div>
                  )}
                  {soft?.sourceInfo?.sellInfo?.currentPrice &&
                    soft?.sourceInfo?.sellInfo?.originalPrice &&
                    soft?.sourceInfo?.sellInfo?.currentPrice !==
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                      <>
                        <div className={`soft_price_c`}>
                          ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                        </div>
                        <div className={`soft_price_o`}>
                          ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                        </div>
                      </>
                    )}
                </div>
              )}

            {soft?.payType === 1 && (
              <div className={`soft_price_co`}>
                {((!soft?.currentPrice && soft?.originalPrice) ||
                  (soft?.currentPrice && !soft?.originalPrice) ||
                  soft?.currentPrice === soft?.originalPrice) && (
                  <div className={`soft_price_c`}>
                    ¥{formatPrice(soft?.currentPrice || soft?.originalPrice)}
                  </div>
                )}
                {soft?.currentPrice &&
                  soft?.originalPrice &&
                  soft?.currentPrice !== soft?.originalPrice && (
                    <>
                      <div className={`soft_price_c`}>¥{formatPrice(soft?.currentPrice)}</div>
                      <div className={`soft_price_o`}>¥{formatPrice(soft?.originalPrice)}</div>
                    </>
                  )}
              </div>
            )}
          </div>
        </div>
        <div className={`soft_infos_box ${styles.mouse_out}`} ref={r => setMoreDom(r)}>
          <div className={`soft_infos`}>
            <div className={`soft_infos_video_img  ${styles.mouse_out}`} ref={r => setMoreVIDom(r)}>
              <div className={`soft_infos_video_img_box`}>
                <ImgVideo soft={soft} styleInfo={{ height: '132px' }} />
              </div>
            </div>
            <div className={`infos ${styles.mouse_out_info}`} ref={r => setMoreInfoDom(r)}>
              <div className={`soft_infos_name`}>{soft?.softName}</div>
              {(!soft?.relationTags ||
                (soft?.relationTags && soft?.relationTags?.length === 0)) && (
                <div
                  className={`soft_infos_desc`}
                  title={soft?.introduction?.length > 8 ? soft?.introduction : ''}
                >
                  {soft?.introduction}
                </div>
              )}

              <div className={`soft_infos_score`}>
                <span className="soft_icon iconfont icon-game_s_zan"></span>
                {parseInt(soft?.scoreRadio || '0') > 70 ? (
                  <span>{soft?.scoreRadio}%好评率</span>
                ) : (
                  <GameRate
                    score={parseInt(parseInt(soft?.score || 60) / 20)}
                    styleType={`black`}
                  />
                )}
              </div>
              <div className={`soft_infos_dl`}>
                <span className="soft_icon iconfont icon-game_s_dl"></span>
                <span>{`${soft.downloadCount}安装`}</span>
              </div>
              {soft?.relationTags && soft?.relationTags?.length > 0 && (
                <div className={`soft_infos_sign`}>
                  <span
                    className="soft_icon iconfont icon-game_s_tag"
                    title={createSoftTag(soft?.relationTags)}
                  ></span>
                  <span>{createSoftTag(soft?.relationTags)}</span>
                </div>
              )}

              <div
                className={`soft_infos_btn`}
                onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                <Button
                  soft={soft}
                  info={{
                    btnStyle: logInfo?.tag?.indexOf('Game_') > -1 ? 'black' : '',
                    className: styles.soft_button,
                    className_busing: styles.soft_button_busing,
                    className_open: styles.button_open,
                  }}
                  logInfo={logInfo}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </_LogInView>
  );
});
